import type { FaireProductEntity } from "../../entity_types/product";

export const p_4t9bv6j9az: FaireProductEntity = {
  token: "p_4t9bv6j9az",
  type: "product",
  name: "Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/4dbf176cf447f73b6dffcb5724aace4e98e7b33dffe06acb21c7e7d1fabae94a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20eaaac8af4f601ce01908d4413d70275c85edf6ca89c92fd4546a353e7b392e.jpeg",
    "https://cdn.faire.com/fastly/b245a25b6a6bf9b0992f384c130dee9c4bb7ac7f4b15df740bbd472dbd996659.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/27e46125a15ba4ecc415af90ae4c8998ccbbea0f8b8fca18599b1ed4654766e9.jpeg",
    "https://cdn.faire.com/fastly/9621b98e3339ef88e8334e4a28744f52f184b1bd1ebcbf53dd2d75ef6e97ba17.jpeg",
    "https://cdn.faire.com/fastly/c8a58aa91572ef70a35569bb208adb918ca09a001cb8fdd65198b3a0c749f54d.jpeg",
    "https://cdn.faire.com/fastly/d3a206c70977e0f6bf784ad897bd3dfed7752ae36eca31bc4c67ee90cf3030ff.jpeg"
  ],
  priceDollars: 6.75,
  description: "Reclaimed, redefined, and ridiculously fun. Practice your slut walk in these flashy socks made for people who own their proclivities with pride and swagger.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:52.631Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
